import upsell from "../upsell"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("shopping_list"),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initUpsell()
  },
})
